export default "__VITE_ASSET__DtERlnZn__"